/** GLSL ES 3.00 snippets shared by several programs. */

export const HASH = /* glsl */ `
uint pcg(uint v) {
  uint state = v * 747796405u + 2891336453u;
  uint word = ((state >> ((state >> 28u) + 4u)) ^ state) * 277803737u;
  return (word >> 22u) ^ word;
}
float hash1(uint v) { return float(pcg(v)) * (1.0 / 4294967295.0); }
vec3 hash3(uint v) {
  uint a = pcg(v);
  uint b = pcg(a);
  uint c = pcg(b);
  return vec3(float(a), float(b), float(c)) * (1.0 / 4294967295.0);
}
`;

/** Field grid layout. Fine and coarse atlases share the world box. */
export const GRID = {
  fine: { g: [64, 32, 64] as const, tilesX: 8, atlas: [512, 256] as const, scale: 64 },
  coarse: { g: [16, 8, 16] as const, tilesX: 4, atlas: [64, 32] as const, scale: 16 },
  global: { g: [1, 1, 1] as const, tilesX: 1, atlas: [1, 1] as const, scale: 4096 },
} as const;

export const GRID_GLSL = /* glsl */ `
const vec3 FG = vec3(${GRID.fine.g.join('.0, ')}.0);
const float FTX = ${GRID.fine.tilesX}.0;
const vec2 FATLAS = vec2(${GRID.fine.atlas.join('.0, ')}.0);
const float FINE_SCALE = ${GRID.fine.scale}.0;
const vec3 CG = vec3(${GRID.coarse.g.join('.0, ')}.0);
const float CTX = ${GRID.coarse.tilesX}.0;
const vec2 CATLAS = vec2(${GRID.coarse.atlas.join('.0, ')}.0);
const float COARSE_SCALE = ${GRID.coarse.scale}.0;
const float GLOBAL_SCALE = ${GRID.global.scale}.0;

// Trilinear read of a 3D grid stored as a 2D atlas of z-slices.
vec4 sampleAtlas(sampler2D tex, vec3 p, vec3 boxMin, vec3 boxSize, vec3 G, float TX, vec2 atlas) {
  vec3 g = (p - boxMin) / boxSize * G;
  g = clamp(g, vec3(0.5), G - 0.5);
  float z = g.z - 0.5;
  float z0 = min(floor(z), G.z - 2.0);
  float fz = z - z0;
  float z1 = z0 + 1.0;
  vec2 t0 = vec2(mod(z0, TX), floor(z0 / TX));
  vec2 t1 = vec2(mod(z1, TX), floor(z1 / TX));
  vec2 uv0 = (t0 * G.xy + g.xy) / atlas;
  vec2 uv1 = (t1 * G.xy + g.xy) / atlas;
  return mix(texture(tex, uv0), texture(tex, uv1), fz);
}
`;

export const FULLSCREEN_VS = /* glsl */ `#version 300 es
void main() {
  // Two triangles from gl_VertexID, no buffers.
  vec2 v = vec2(float((gl_VertexID << 1) & 2), float(gl_VertexID & 2));
  gl_Position = vec4(v * 2.0 - 1.0, 0.0, 1.0);
}
`;
